import React, { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { stopDirectEditingNote, startDirectEditingNote } from 'data/ui/actions'
import { selectors as UISelectors } from 'data/ui'
import { selectors as NotesSelectors } from 'data/notes'

import Button from 'components/base/Button'
import { PenIcon } from 'components/Utils/Icons'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

export default function TopBarDirectEdit() {
  // #region data setup */
  const dispatch = useDispatch()
  const isDirectEditingNote = useSelector(UISelectors.isDirectEditingNote)
  const activeNoteId = useSelector(UISelectors.getActiveNoteId)
  const noteIsLockedForEdition = useSelector(state =>
    NotesSelectors.isLockedForEdition(state, activeNoteId)
  )

  const stopDirectEditingNoteAction = useCallback(
    () => dispatch(stopDirectEditingNote()),
    [dispatch]
  )
  const startDirectEditingNoteAction = useCallback(
    () => dispatch(startDirectEditingNote()),
    [dispatch]
  )

  const handleDirectEditClick = React.useCallback(
    () => {
      if (isDirectEditingNote) {
        return stopDirectEditingNoteAction()
      }

      startDirectEditingNoteAction()
    },
    [
      isDirectEditingNote,
      stopDirectEditingNoteAction,
      startDirectEditingNoteAction,
    ]
  )
  // #endregion

  if (!noteIsLockedForEdition) {
    return null
  }

  const ButtonInUse = isDirectEditingNote ? Button.Secondary : Button.Primary

  return (
    <TooltipOnHover
      id="topbar-direct-edit"
      // For some reason the tooltip bugs when re-used. Let's re-render it on change
      key={isDirectEditingNote}
      placement="bottom"
      tooltipContent={
        <React.Fragment>
          <p className="font-weight-bold center-text">
            {isDirectEditingNote ? 'Editing' : 'Editing protected'}
          </p>
          <p className="font-weight-normal center-text">
            {isDirectEditingNote ? 'Click to protect' : 'Click to edit'}
          </p>
        </React.Fragment>
      }
    >
      <ButtonInUse
        slim
        className="flexbox flexbox-no-shrink flexbox-align-center margin-right-small"
        onClick={handleDirectEditClick}
      >
        {!isDirectEditingNote && <PenIcon className="margin-right-small" />}
        <span className="no-wrap">{isDirectEditingNote ? 'Done' : 'Edit'}</span>
      </ButtonInUse>
    </TooltipOnHover>
  )
}
